import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai"; // Import React Icons
import { VscChevronLeft, VscChevronRight } from "react-icons/vsc";
import { Link } from "react-router-dom";


import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "./Brand1.css"; // Ensure the file exists

const Brand1 = ({data}) => {
  const baseImageUrl = "https://grobizapp-n.s3.ap-south-1.amazonaws.com/brands/";
const slides = data.get_home_component_details.content.map((brand) => ({
  img: `${baseImageUrl}${brand.brand_image_app}`, // Replace with actual base URL if needed
  title: brand.brand_name,
  brandId: brand.brand_auto_id,
  brandName: brand.brand_name,
}));

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section
      className="p-1 "
      style={{
        backgroundColor: data.web_background_color,
      }}
    >
      <h2
        className={`text-${data.title_alignment} text-3xl font-bold  mb-4 ${data.web_title_font}`}
        style={{
          color: data.web_title_color,
        }}
      >
        {data.title}
      </h2>
      <div className="flex justify-center">
        <Swiper
  modules={[Navigation, EffectCoverflow]}
  effect="coverflow"
  grabCursor={true}
  centeredSlides={true}
  slidesPerView={"auto"}
  loop={slides.length > 1}
  navigation={{
    nextEl: ".brand1-next",
    prevEl: ".brand1-prev",
  }}
  coverflowEffect={{
    rotate: 0,
    stretch: 0,
    depth: 200,
    modifier: 1,
    slideShadows: false,
  }}
  className="w-full px-6"
>

  {slides.map((slide, index) => (
    <SwiperSlide
      key={index}
      className="!w-64 sm:!w-72"   // Width same as screenshot
    >
      <Link
        to="/brandlist"
        state={{
          brand_id: slide.brandId,
          brand_name: slide.brandName,
        }}
      >
        <div className="bg-white rounded-2xl overflow-hidden shadow-md">
          <img
            src={slide.img}
            alt={slide.title}
            className="w-full h-80 object-cover"
          />
        </div>
      </Link>
    </SwiperSlide>
  ))}

  {/* Right Arrow */}
  <div className="brand1-next absolute right-2 top-1/2 -translate-y-1/2 z-20 
       bg-white rounded-full shadow p-2 text-2xl">
    <VscChevronRight />
  </div>

  {/* Left Arrow */}
  <div className="brand1-prev absolute left-2 top-1/2 -translate-y-1/2 z-20
       bg-white rounded-full shadow p-2 text-2xl">
    <VscChevronLeft />
  </div>

</Swiper>

      </div>
    </section>
  );
};

export default Brand1;
